import React from 'react';
import { FormSectionTitle } from '../atoms/FormSectionTitle';

export const LabelSection: React.FC<{
  title: string;
  value: string;
  id?: string;
}> = (props) => {
  return (
    <div>
      <FormSectionTitle text={props.title} htmlFor={props.id} />
      <p className={'text-[--c-text] pt-[10px]'} id={props.id}>
        {props.value}
      </p>
    </div>
  );
};
